import React from 'react';
import { useLocale } from 'src/lib/hook/useLocale';
import styles from './style.module.scss';
import completedSurveySmileDefault from './assets/completedSurveySmileDefault.svg';
import completedSurveySmileBhvk from './assets/completedSurveySmileBhvk.svg';

interface FinishSurveyDisplayProps {
  isVisible: boolean;
  isBhvkTheme: boolean;
}

export const FinishSurveyDisplay: React.FC<FinishSurveyDisplayProps> = ({ isVisible, isBhvkTheme }) => {

  const { t } = useLocale();
  if (!isVisible) return null;

  return (
    <div className={styles['popup-overlay']}>
      <div className={styles['popup-content']}>
        {isBhvkTheme ? <img src={completedSurveySmileBhvk} alt="completed survey smile in svg" className={styles['popup-image']}/>
          : <img src={completedSurveySmileDefault} alt="completed survey smile in svg" className={styles['popup-image']}/>
        }
        <div className={styles.signs}>
          <div className={styles['sign-thanks']}>{t('component.finishSurveyDisplay.thanks')}</div>
          <div className={styles['sign-explanation']}>{t('component.finishSurveyDisplay.explanation')}</div>
        </div>
      </div>
    </div>
  );

};
